// extracted by mini-css-extract-plugin
module.exports = {"root":"App_root__2h8CC","App":"App_App__16ZpL"};